import { render, staticRenderFns } from "./Custom-Buttons.vue?vue&type=template&id=d44012c2&scoped=true&"
import script from "./Custom-Buttons.vue?vue&type=script&lang=js&"
export * from "./Custom-Buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44012c2",
  null
  
)

export default component.exports